
















import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'

const metaInfo = () => ({
  title: $.t('view.manage.companyList.title'),
})

@Component({
  metaInfo,
  components: {},
})
export default class ManageCompanyListView extends Mixins(MixinFilter) {
  // filter = new ...()
  // collection = new PageCollection(..., this.filter, 10)

  async populate() {
    await this.query()
  }
}
